import React from 'react'
import './OtherProject.css'
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded'

function OtherProject({ title, info, github, techStack }) {
  return (
    <div className='otherProject'>
      <div className='otherProject__title'>
        <a href={github} target='_blank' rel='noreferrer'>
          <h4>{title}</h4>
          <ArrowForwardRoundedIcon />
        </a>
      </div>
      <p className='otherProject__info'>{info}</p>
      <div className='otherProject__techStack'>
        {techStack.map((technology) => (
          <div className='otherProject__tech'>{technology}</div>
        ))}
      </div>
    </div>
  )
}

export default OtherProject
